export enum SeoTagType {
  title,
  description,
}
